import { getBlankRecord } from "./helpers";
import * as mutation from "./mutation-types";

export const state = getInitialState();

export function getInitialState() {
  return {
    listing: {
      providerId: null,
      levyCollectionId: null,
      data: [],
      loading: false,
      loaded: false
    },
    edit: {
      data: getBlankRecord(),
      loading: false,
      saving: false,
      isNew: true,
      error: {
        show: false,
        details: {},
        hideMutation: mutation.STATE_HIDE_ERROR,
        hideArgument: "edit"
      }
    },
    delete: {
      processing: false
    }
  };
}

export function getUnloadedState() {
  return {
    listing: {
      loaded: false
    }
  };
}
